import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Switch, { SWITCH_SIZES } from "components/DesignComponents/Switch";
import { body2SemiBold, USER_STATUSES } from "shared";

import { ExpirationDate } from "../../../components";
import { UserStatusProps } from "./types";

const UserStatus = ({
    status,
    expirationDate,
    isLoading,
    onStatusChange,
    onExpirationDateChange,
    onExpirationDateError
}: UserStatusProps) => {
    const { gray300, green700, textPlaceholder } = colors;

    const { t } = useTranslation();

    const isActive = status === USER_STATUSES.Active;

    return (
        <div>
            <ExpirationDate
                expirationDate={expirationDate}
                isActive={isActive}
                isLoading={isLoading}
                onExpirationDateChange={onExpirationDateChange}
                onExpirationDateError={onExpirationDateError}
            />

            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    columnGap: "8px",
                    border: `1px solid ${gray300}`,
                    borderRadius: "8px",
                    padding: "15px",
                    margin: "16px 0"
                })}
            >
                <div
                    css={[
                        body2SemiBold,
                        {
                            "& > span:last-of-type": {
                                color: isActive ? green700 : textPlaceholder
                            }
                        }
                    ]}
                >
                    <span>{t("Dialog##user")}:</span>{" "}
                    <span>{t(`Table##user statuses##${status}`)}</span>
                </div>

                <Switch
                    size={SWITCH_SIZES.Medium}
                    checked={isActive}
                    onChange={(_, isChecked) => onStatusChange(isChecked)}
                    disabled={isLoading}
                />
            </div>
        </div>
    );
};

export default UserStatus;
